import { useState } from 'react';

// eslint-disable-next-line @typescript-eslint/ban-types
type Optional<T extends object> = {
  [K in keyof T]?: T[K];
};

// eslint-disable-next-line @typescript-eslint/ban-types
export const useStateHandlers = <T extends object>(
  initialState: T,
): [T, (newState: Optional<T> | ((prevState: T) => Optional<T>)) => void] => {
  const [state, setState] = useState(initialState);

  const setNewState = (newState: Optional<T> | ((prevState: T) => Optional<T>)): void => {
    if (typeof newState === 'function') {
      setState((prevState) => ({ ...prevState, ...newState(prevState) }));
    } else {
      setState((prevState) => ({
        ...prevState,
        ...newState,
      }));
    }
  };

  return [state, setNewState];
};
